import { StatusState } from '@gripp/shared-logic';
import { useTranslation } from 'react-i18next';
import { MessageComponent, MessageComponentProps } from '../../issue/types';
import { CommonRoutineMessage } from '../components/commonRoutineMessage';

export const StatusMessage: MessageComponent = (
  props: MessageComponentProps
) => {
  const assetRoutine = props.message.assetRoutine;
  const { t } = useTranslation();
  const data = assetRoutine.data as StatusState;
  const routineOpenEndedResponseText = data?.openEndedResponse
    ? `${t('routines.status.admin.openEndedResponse')}: ${
        data.openEndedResponse
      }`
    : '';
  const routineText = `Status: ${data.status}
${routineOpenEndedResponseText}`;

  return <CommonRoutineMessage routineText={routineText} {...props} />;
};
